import React from 'react';
import IconFromImage from '../IconFromImage/IconFromImage';
import tableSrc from './assets/table.svg';

const FunnelIcon = () => (
    <IconFromImage type="table" src={tableSrc} />
);

export default FunnelIcon;
